export enum PalletPassportTemplateField {
    ID = 'id',
    NAME = 'name',
    HTML_CONTENT = 'htmlContent',
}
